<div class="tab-content">
    <div class="hero-text" style="margin-left: 10px;">
        <h1 style="font-weight: 800;">Firmware {{'CREATE' | translate}}</h1>
    </div>
    <form #firmwareForm="ngForm" (ngSubmit)="firmwareForm.form.valid" novalidate>
        <mat-form-field appearance="outline" floatLabel="always" class="w-100-p">
            <mat-label>Model</mat-label>
            <input matInput placeholder="Model" [(ngModel)]="model.Model" name="model" required>
        </mat-form-field>

        <mat-form-field *ngIf="companyId==1" appearance="outline" floatLabel="always" class="w-100-p">
            <mat-label>{{'COMPANY' | translate}}</mat-label>
            <mat-select [(ngModel)]="selectedCompany" required name="companies">
                <mat-option *ngFor="let item of companyList" name="copaniesOptions" [value]="item.id">
                    {{item.name}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" floatLabel="always" class="w-100-p">
            <mat-label>{{'VERSION' | translate}}</mat-label>
            <input matInput placeholder="Version" [(ngModel)]="model.Version" name="vers" required>
        </mat-form-field>
        
        <mat-form-field appearance="outline" floatLabel="always" class="w-100-p">
            <mat-label>{{'DESCRIPTION'|translate}}</mat-label>
            <textarea matInput placeholder="{{'DESCRIPTION'|translate}}" maxlength="255" [(ngModel)]="model.desciription" name="desciription"></textarea>
        </mat-form-field>

        <div class="firmware-file-input">
            <form enctype="multipart/form-data">
                <input (change)="fileChange($event.target.files)" accept=".dat,.txt" type="file"
                    placeholder="Basic outline placeholder">
            </form>
        </div>
        <button mat-raised-button (click)="save(firmwareForm)">
            <span>{{'CREATE' | translate}}</span>
        </button>
    </form>
</div>